import React from 'react';
import { Grid } from '@mui/material';

import { InfoField } from '@occc/ui-design-system';
import { AwardMoneyDiscountFragment, Award_Per_Counting_Strategy } from '@occc/graphql';

interface IMoneyDiscountAwardProps {
  award: AwardMoneyDiscountFragment;
}

type CountingStrategyMap = {
  [key in Award_Per_Counting_Strategy]: string;
};

const countingStrategyMap: CountingStrategyMap = {
  [Award_Per_Counting_Strategy.TotalPurchase]: 'Total Purchase',
  [Award_Per_Counting_Strategy.IndividualPurchase]: 'Individual Purchase',
  [Award_Per_Counting_Strategy.SellingUnitPurchase]: 'Selling Unit Purchase',
};

const formatCountingStrategy = ({ awardPer }: { awardPer: Award_Per_Counting_Strategy }): string =>
  countingStrategyMap[awardPer];

export const MoneyDiscountAward: React.FC<IMoneyDiscountAwardProps> = ({ award }) => {
  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <InfoField label='Money Amount' value={award?.moneyAmount} />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Counting Strategy' value={formatCountingStrategy(award)} />
      </Grid>
    </Grid>
  );
};
